import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright, } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from '../../Redux/store';
const Footer = React.memo(() => {
    const mobileApplicationStore = useSelector(state => state.mobileApplication);
    return (React.createElement(React.Fragment, null, mobileApplicationStore ?
        React.createElement(React.Fragment, null)
        :
            React.createElement("footer", { className: "fixed left-0 bottom-0 p-2 w-full bg-haikan-red" },
                React.createElement("div", { className: "text-center text-white lg:text-sm text-xs" },
                    React.createElement(FontAwesomeIcon, { icon: faCopyright, className: `` }),
                    "2022 \u307F\u3093\u306A\u306E\u30D2\u30FC\u30ED\u30FC"))));
});
export default Footer;
